// safeCall — invoke a registered function via el.call without throwing
// when the function isn't registered in the current context.
//
// `el.call(name)` THROWS on an unknown function. That's the right default
// for app code, but PORTABLE shared components (e.g. the Zoombar, mounted
// in the shell AND every canvas sub-app) legitimately can't assume every
// host registers every helper they'd like to use — getGlobalTheme /
// getCookie / setCookie / removeCookie exist in the shell context but not
// in the canvas (scratch) context, for instance. Rather than register the
// full helper set into every possible host (fragile — each new host must
// remember), such components resolve optional helpers defensively: call
// if present, fall back gracefully if not.
//
// Returns the function's result, or undefined when it isn't registered
// (or throws). Use ONLY for genuinely-optional helpers — app code that
// depends on a function being present should call it directly so a real
// missing-registration bug surfaces loudly.
export const safeCall = (el, fn, ...args) => {
  try {
    return el?.call?.(fn, ...args)
  } catch (_) {
    return undefined
  }
}
